import { useHovered, SharedHoveredProps } from '../../utils/useHovered';
import { IndexableObject } from '../../utils/IndexableObject';
import type { JSX } from 'react';

export interface HoverProviderProps
  extends SharedHoveredProps,
    IndexableObject {
  children: ({
    hovered,
    onMouseEnter,
    onMouseLeave,
    onMouseMove,
  }: SharedHoveredProps) => JSX.Element;
}

export const HoverProvider = (props: HoverProviderProps) => {
  return props.children(useHovered(props));
};

HoverProvider.displayName = 'HoverProvider';
